export default function Python_OOP() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Python_OOP</h1>
      <p>Content for Python_OOP goes here.</p>
    </div>
  );
}